'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _elementType = require('react-prop-types/lib/elementType');

var _elementType2 = _interopRequireDefault(_elementType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  href: _react2.default.PropTypes.string,
  onClick: _react2.default.PropTypes.func,
  disabled: _react2.default.PropTypes.bool,
  role: _react2.default.PropTypes.string,
  tabIndex: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]),
  /**
   * this is sort of silly but needed for Button
   */
  componentClass: _elementType2.default
};

var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */

var SafeAnchor = function (_React$Component) {
  (0, _inherits3.default)(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    (0, _classCallCheck3.default)(this, SafeAnchor);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SafeAnchor.__proto__ || (0, _getPrototypeOf2.default)(SafeAnchor)).call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SafeAnchor, [{
    key: 'handleClick',
    value: function handleClick(event) {
      var _props = this.props,
          disabled = _props.disabled,
          href = _props.href,
          onClick = _props.onClick;


      if (disabled || isTrivialHref(href)) {
        event.preventDefault();
      }

      if (disabled) {
        event.stopPropagation();
        return;
      }

      if (onClick) {
        onClick(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          Component = _props2.componentClass,
          disabled = _props2.disabled,
          props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'disabled']);


      if (isTrivialHref(props.href)) {
        props.role = props.role || 'button';
        // we want to make sure there is a href attribute on the node
        // otherwise, the cursor incorrectly styled (except with role='button')
        props.href = props.href || '';
      }

      if (disabled) {
        props.tabIndex = -1;
        props.style = (0, _extends3.default)({ pointerEvents: 'none' }, props.style);
      }

      delete props.bsStyle;

      return _react2.default.createElement(Component, (0, _extends3.default)({}, props, {
        onClick: this.handleClick
      }));
    }
  }]);
  return SafeAnchor;
}(_react2.default.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;

exports.default = SafeAnchor;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/SafeAnchor.js
// module id = 280
// module chunks = 0